import { createUrl } from "../create-url";
import { TFunnelRoutes, TRoutes } from "../routes.types";

export const funnel: TFunnelRoutes = {
  recoverPassword: () =>
    createUrl("/recover-password"),
} satisfies TRoutes;
